settingsMenuButton = {};

settingsMenuButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return this._flags.canSpin && !this._flags.autoplayStarted && !this._flags.modal.active;
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    soundManager.play('buttonPressed');
    settingsMenu.showPopup();
  };

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.onConfig = function (config) {
    button._flags.platformEnabled = config.data.uiElements.btnSettings.enabled;
    button._flags.platformVisible = config.data.uiElements.btnSettings.visible;
  };

  messageBus.subscribe('spinner:GameConfigEvent', button.onConfig);

  return button;
};

settingsMenuButton.initialise = function (json, object) {};
settingsMenuButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'settingsMenuButton',
  settingsMenuButton.create,
  settingsMenuButton.initialise,
  settingsMenuButton.getFilesRequired
);
